export default __webpack_public_path__ + "static/media/simon_inactive.e112a636.svg";